import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  /** @type {boolean} */
  #viewCartFiredForThisOpen = false;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open') && window.innerWidth >= 768) {
      this.showDialog();

      if (!this.#viewCartFiredForThisOpen) {
        this.#viewCartFiredForThisOpen = true;
       // this.#fireViewCartEvent();
      }
    }
  };

  close() {
    this.#viewCartFiredForThisOpen = false;
    this.closeDialog();
  }

  open() {
    if (window.innerWidth < 768) {
      window.location.href = Theme.routes.cart_url;
      return;
    }

    this.showDialog();

    if (!this.#viewCartFiredForThisOpen) {
      this.#viewCartFiredForThisOpen = true;
    //  this.#fireViewCartEvent();
    }

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  /**
   * Fetch /cart.js and push view_cart via ShopAnalytics
   * (desktop cart drawer only)
   */
  #fireViewCartEvent = () => {
    if (
      !window.ShopAnalytics ||
      !window.ShopAnalytics.events ||
      typeof window.ShopAnalytics.events.viewCart !== 'function'
    ) {
      return;
    }

    fetch('/cart.js')
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch cart.js');
        return res.json();
      })
      .then((cart) => {
        window?.ShopAnalytics?.events.viewCart({
          cart,
          source: 'mini_cart',
        });
      })
      .catch((err) => {
        console.error('view_cart (mini_cart) cart.js error', err);
      });
  };
}


if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
